import React, { useContext, useState } from 'react'
import './Navbar.css'
import { IconButton, Avatar, Menu, MenuItem, useMediaQuery, InputBase } from '@mui/material';
import { styled, alpha, createTheme, ThemeProvider } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import AppsIcon from '@mui/icons-material/Apps';
import AuthContext from '../../context/AuthProvider';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useSelector } from 'react-redux';
import AccountPopover from '../../components2/header/AccountPopover';
import { useLocalContext } from '../../context/Context';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';

const theme = createTheme();

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));
  
  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));

function StudentNavbar() {
    const { auth, setAuth, login } = useContext(AuthContext)
    const { createClassDialog, setCreateClassDialog} = useLocalContext()
    //const userName = localStorage.getItem('first_name')
    const { firstName } = useSelector((state) => state.user)
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'));
    const navigate = useNavigate()

    const handleAvatarClick = () => {
        setIsPopoverOpen((prev) => !prev);
      };

  return (
    <nav className='navbar'>
        <div className='navbar__left'>
        <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
            />
          </Search>
        </div> 
        <div className='navbar__right'>
           {/* <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
            >
                <AddIcon />
            </IconButton> */}
            <IconButton>
                <NotificationsNoneOutlinedIcon />
            </IconButton>
          {/*}  <IconButton onClick={handleAvatarClick}>
                <Avatar />
        </IconButton> */}

            <AccountPopover />
            </div>
        </nav>
  )
}

export default StudentNavbar